module.exports = __webpack_public_path__ + "img/IMG_3450_L_Black.2fdb12bc.jpg";